import React from 'react';
import ReactDOM from 'react-dom';
import videojs from 'video.js';
import MenuSelector from './MenuSelector';
const vjsComponent = videojs.getComponent('ClickableComponent');
class MenuQualitySelector extends vjsComponent {
    constructor(player, options) {
        super(player, options);
        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this);
        /* When player is ready, call method to mount React component */
        player.ready(() => {
            this.mount();
        });
        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el());
        });
    }
    buildCSSClass() {
        return `vjs-quality-selector-buttons ${super.buildCSSClass()}`;
    }
    handleClick(e) {
        const prevSelectedOption = this.$('.selected');
        if (!(e.target instanceof HTMLButtonElement))
            return;
        const newSelectedOption = e.target;
        //ignore if value is not being updated
        if (newSelectedOption.innerHTML === prevSelectedOption.innerHTML) {
            return;
        }
        prevSelectedOption.classList.remove('selected');
        newSelectedOption.classList.add('selected');
        const newVideoQuality = newSelectedOption.value;
        this.setVideoQuality(newVideoQuality);
    }
    setVideoQuality(newQuality) {
        var _a;
        const qualityLevel = Number(newQuality);
        const qualityLevels = (_a = this.player()) === null || _a === void 0 ? void 0 : _a.qualityLevels();
        if (qualityLevels) {
            for (let i = 0; i < qualityLevels.length; ++i) {
                const quality = qualityLevels[i];
                quality.enabled = quality.height === qualityLevel || newQuality === 'auto';
            }
        }
    }
    /**
     * We will render out the React QualitySelector component into the DOM element
     * generated automatically by the VideoJS createEl() method.
     *
     * We fetch that generated element using `this.el()`, a method provided by the
     * vjsComponent class that this class is extending.
     */
    mount() {
        //timeout to wait for video to load and populate available quality levels
        setTimeout(() => {
            var _a, _b;
            const qualityLevels = (_b = (_a = this.player()) === null || _a === void 0 ? void 0 : _a.qualityLevels()) === null || _b === void 0 ? void 0 : _b.levels_;
            if (!qualityLevels) {
                return;
            }
            qualityLevels.sort((a, b) => Number(a.height) - Number(b.height));
            if (qualityLevels.length === 0) {
                this.disable();
            }
            const options = qualityLevels.reduce((prev, level) => {
                const name = `${level.height}p`;
                const value = level.height;
                prev.push({ name, value });
                return prev;
            }, [{ name: 'AUTO', value: 'auto' }]);
            ReactDOM.render(React.createElement(MenuSelector, { options: options, type: 'quality', default: 'AUTO' }), this.el());
        }, 1500);
    }
}
export default MenuQualitySelector;
//# sourceMappingURL=MenuQualitySelector.js.map